import RestApiClient from '../../core/api/RestApiClient';

class ChangePasswordApiClient {
  public async changePassword(oldPassword: string, newPassword: string) {
    return await RestApiClient.post('modules/ChangePassword', { oldPassword, newPassword });
  }
}

export default new ChangePasswordApiClient();
